import React from 'react';
export function CompleteSystemOffer() {
  return <div className="max-w-4xl mx-auto mb-8 text-center" data-id="element-188" data-mp="38zdbaq9upuyy">
      <h2 className="text-2xl md:text-4xl font-bold text-black mb-8" data-id="element-189" data-mp="2qp8wybfg779m">
        Hoy puedes acceder al sistema completo
      </h2>
      {/* Visual representation of the full stack */}
      <div className="mb-8 flex justify-center" data-id="element-190" data-mp="2hp3wymcl3b5h">
        <img src="https://cdn.magicpatterns.com/uploads/tZ5HNHL7yceUkm8W1gJPub/Screenshot_2026-01-08_at_11.02.51_PM.png" alt="Complete Bootcamp System with all modules and bonuses" className="w-full max-w-4xl h-auto object-contain" data-id="element-191" data-mp="2hoasxt50ezr1" />
      </div>
      <div className="mt-12" data-id="element-192" data-mp="22zoahik35rvl">
        <div className="relative inline-block" data-id="element-193" data-mp="230zdvh9mcxm6">
          <span className="text-3xl md:text-5xl font-bold text-red-500 line-through decoration-4 decoration-red-500 opacity-80" data-id="element-194" data-mp="22xl9k3heaec3">
            $3,970 valor regular
          </span>
        </div>
        <div className="flex items-center justify-center gap-3 mt-4" data-id="element-195" data-mp="1u12kj2cabaks">
          <span className="text-3xl md:text-5xl font-bold text-black" data-id="element-196" data-mp="1p0onsgg4vn22">
            Solo por
          </span>
          <span className="text-5xl md:text-7xl font-black text-[#06b6d4]" data-id="element-197" data-mp="faw2l0v1ocuj">
            $297
          </span>
        </div>
      </div>
    </div>;
}